import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'
export const FEEDBACK_API_PATH = '/api/v4/bit/feedback/my/list'
export const FEEDBACK_DETAIL_API_PATH = '/api/v4/bit/web/feedback/detail'
export const WEB_FEEDBACK_PAGE_LIST_API_PATH = '/api/v4/bit/web/feedback/page/list'
export const FEEDBACK_REPORT_REASONS_API_PATH = '/api/v4/bit/web/feedback/report-reasons'
export const FEEDBACK_REPORT_API_PATH = '/api/v4/bit/web/feedback/report'
export const FEEDBACK_FINISH_GRADE_API_PATH = '/api/v4/bit/web/feedback/finishgrade'

export type FeedbackImageItem = {
  list?: string // 列表图
  detail?: string // 详情图
  url?: string
  width?: number
  height?: number
  isAiCreate?: number // 是否 ai 生成
  aiImageIcon?: string // ai 生成显示 icon
  word?: string // ai 展示文案
}

export type FeedbackListItem = {
  userInfo: WebFeedbackPageUserInfo
  tokenGradeCommentInfo: {
    publishTime?: string | number
    evaluateIcon?: string
    evaluateName?: string
    evaluateType?: number
    evaluateCode?: string
    commentGradeId?: string
    languageCode?: string
    content?: string
    translateContent?: string
    title?: string
    translateTitle?: string
    images?: FeedbackImageItem[]
    auditStatus?: string
  }
  isShow?: boolean
}

export type FeedbackStatusTab = {
  type?: number
  text?: string
}

export type FeedbackListData = {
  tags?: FeedbackStatusTab[]
  list?: FeedbackListItem[]
  total?: number
}

export type FeedbackListResponse =
  | {
      code?: number
      data?: FeedbackListData
      message?: string
      succeed?: boolean
    }
  | FeedbackListData

export type FeedbackListParams = {
  userId: string
  status: number
  pageIndex: number
  size: number
}

export type WebFeedbackPageLabel = {
  name?: string
  text?: string
  value?: string | number
  count?: string | number
}

export type WebFeedbackPageImageItem = {
  list?: string
  detail?: string
  url?: string
  width?: number
  height?: number
  isAiCreate?: boolean | number
  aiImageIcon?: string
  word?: string
}

export type WebFeedbackPageUserInfo = {
  nickName?: string
  userId?: string
  publishTime?: string
  publishTimeMil?: string
  avatarAddress?: string
}

export type WebFeedbackPageTag = {
  text?: string
  name?: string
  title?: string
}

export type WebFeedbackPageCommentInfo = {
  commentGradeId?: string
  title?: string
  content?: string
  translateTitle?: string
  translateContent?: string
  gradeName?: string
  negativeType?: string
  country?: string
  publishTime?: string
  image?: WebFeedbackPageImageItem[] | null
  images?: WebFeedbackPageImageItem[] | null
  tags?: Array<WebFeedbackPageTag | string> | null
}

export type WebFeedbackPageListItem = {
  userInfo?: WebFeedbackPageUserInfo | null
  tokenGradeCommentInfo?: WebFeedbackPageCommentInfo | null
}

export type WebFeedbackPageListData = {
  labels?: WebFeedbackPageLabel[] | null
  list?: WebFeedbackPageListItem[] | null
  pageSize?: number
  pageIndex?: number
  total?: number
  pageCount?: number
  isShowReply?: boolean
  showTotal?: unknown
  isBitWhitelist?: boolean
  isSmallWhitelist?: boolean
  tips?: unknown[] | string | null
  whiteListTips?: unknown
  whiteListTipsUserImages?: unknown
  showType?: number
}

export type WebFeedbackPageListResponse =
  | {
      code?: number
      data?: WebFeedbackPageListData
      result?: WebFeedbackPageListData
      message?: string
      succeed?: boolean
    }
  | WebFeedbackPageListData

export type WebFeedbackPageListParams = {
  code: string
  searchType?: number
  pageIndex?: number
  pageSize?: number
}

export type FeedbackDetailParams = {
  /** 反馈列表返回的评论反馈 ID，用于查询详情。 */
  commentGradeId: string
  userLoginId?: string
}

export type FeedbackUserInfo = {
  avatarAddress?: string
  nickName?: string
  publishTime?: string
  userId?: string
  flag?: string
  country?: string
  countryName?: string
}

export type FeedbackTokenGradeInfo = {
  commentGradeId?: string
  content?: string
  translateContent?: string
  country?: string
  countryCode?: string
  evaluateCode?: string
  evaluateIcon?: string
  evaluateName?: string
  localEvaluateName?: string
  evaluateType?: number
  gradeName?: string
  grade?: number
  negativeType?: string
  tags?: Array<WebFeedbackPageTag | string> | null
  images?: FeedbackImageItem[]
  applaudCount?: number
  forwardCount?: number
  isApplaud?: boolean
  publishTime?: string | number
  shareUrl?: string
  title?: string
  translateTitle?: string
  lastPage?: FeedbackPageItem
  nextPage?: FeedbackPageItem
  languageCode?: string
  isFinishFeedback?: boolean
}

export type FeedbackPageItem = {
  commentGradeId?: string
  content?: string | null
  grade?: number
  title?: string
}

export type FeedbackWebBitBottom = {
  code?: string
  icon?: string
  name?: string
  score?: string
  labels?: Array<{ name?: string; color?: string; type?: number }>
  alias?: string
}

export type FeedbackWeekRanking = {
  code?: string
  icon?: string
  name?: string
  alias?: string
}

export type FeedbackDetailData = {
  tokenGradeCommentInfo?: FeedbackTokenGradeInfo
  userInfo?: FeedbackUserInfo
  webBitWebBottom?: FeedbackWebBitBottom
  weekRankings?: FeedbackWeekRanking[]
  totalRankings?: FeedbackWeekRanking[]
  isShow?: boolean
  isShowReply?: boolean
  isSelf?: boolean
}

export type FeedbackDetailResponse = {
  code?: number
  data?: FeedbackDetailData
  message?: string
  succeed?: boolean
}

export type FeedbackReportReason = {
  /** 举报原因编码，提交举报时作为 reasonCode 传给 BFF。 */
  code: string
  /** 举报原因展示名称。 */
  name: string
}

export type FeedbackReportReasonsResponse = {
  code?: number
  /** 举报原因列表实际在 data.list 中。 */
  data?: {
    list?: FeedbackReportReason[]
  }
  statusCode?: number
  result?: FeedbackReportReason[]
  succeed?: boolean
  message?: string | null
  extra?: unknown
  timestamp?: number
}

export type FeedbackReportParams = {
  /** 反馈详情 ID，对应下游 postsId。 */
  postsId: string
  /** 当前登录用户 ID。 */
  userId: string
  /** 举报原因编码。 */
  reasonCode: string
}

export type FeedbackReportResponse = {
  statusCode?: number
  result?: unknown
  succeed?: boolean
  message?: string | null
  extra?: unknown
  timestamp?: number
}

export type FeedbackFinishGradeParams = {
  /** 当前登录用户 ID。 */
  userLoginId: string
  /** 反馈详情 ID。 */
  commentGradeId: string
}

export type FeedbackFinishGradeResponse = {
  code?: number
  data?: unknown
  statusCode?: number
  result?: unknown
  succeed?: boolean
  message?: string | null
  extra?: unknown
  timestamp?: number
}

export const getFeedbackList = (params: FeedbackListParams): Promise<FeedbackListResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: FEEDBACK_API_PATH,
    method: 'GET' as const,
    params,
  }

  return import.meta.server ? useServerFetch<FeedbackListResponse>(requestConfig) : request(requestConfig)
}

/**
 * 获取 Web 交易所详情反馈分页列表，分类数据来自返回体的 labels 字段。
 * @param params 查询参数，code 为交易所 code。
 * @returns BFF 返回的反馈分页数据。
 */
export const getWebFeedbackPageList = (
  params: WebFeedbackPageListParams,
): Promise<WebFeedbackPageListResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: WEB_FEEDBACK_PAGE_LIST_API_PATH,
    method: 'GET' as const,
    params,
  }

  return import.meta.server
    ? useServerFetch<WebFeedbackPageListResponse>(requestConfig)
    : request<unknown, WebFeedbackPageListResponse>(requestConfig)
}

/**
 * 获取反馈详情，SSR 首屏走服务端 BFF，客户端路由切换走浏览器请求。
 * @param params 查询参数，当前使用 commentGradeId 定位反馈详情。
 * @returns 反馈详情接口原始响应。
 */
export const getFeedbackDetail = (params: FeedbackDetailParams): Promise<FeedbackDetailResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: FEEDBACK_DETAIL_API_PATH,
    method: 'GET' as const,
    params,
  }

  return import.meta.server
    ? useServerFetch<FeedbackDetailResponse>(requestConfig)
    : request<unknown, FeedbackDetailResponse>(requestConfig)
}

/**
 * 获取反馈举报原因列表。
 * @returns BFF 返回的举报原因原始响应，result 为原因列表。
 */
export const getFeedbackReportReasons = (): Promise<FeedbackReportReasonsResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: FEEDBACK_REPORT_REASONS_API_PATH,
    method: 'GET' as const,
  }

  return import.meta.server
    ? useServerFetch<FeedbackReportReasonsResponse>(requestConfig)
    : request<unknown, FeedbackReportReasonsResponse>(requestConfig)
}

/**
 * 提交反馈举报。
 * @param data 举报参数，postsId/userId/reasonCode 对应下游 postsreport 入参。
 * @returns BFF 返回的举报提交原始响应。
 */
export const submitFeedbackReport = (data: FeedbackReportParams): Promise<FeedbackReportResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: FEEDBACK_REPORT_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
  }

  return import.meta.server
    ? useServerFetch<FeedbackReportResponse>(requestConfig)
    : request<unknown, FeedbackReportResponse>(requestConfig)
}

/**
 * 确认反馈问题已解决。
 * @param data 当前用户 ID 和反馈详情 ID。
 * @returns BFF 返回的确认已解决原始响应。
 */
export const finishFeedbackGrade = (data: FeedbackFinishGradeParams): Promise<FeedbackFinishGradeResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: FEEDBACK_FINISH_GRADE_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'Content-Type': 'application/json-patch+json',
      'request-from': 'swagger',
    },
  }

  return import.meta.server
    ? useServerFetch<FeedbackFinishGradeResponse>(requestConfig)
    : request<unknown, FeedbackFinishGradeResponse>(requestConfig)
}
